module.exports = "/images/jp.svg?46a8d1cb2d03f2e96f0b8da6ae1aa0fd";